module.exports = __webpack_public_path__ + "static/back-68222110987953c877529049d1d353b8.jpg";